// Reusable Input Component
import React from "react";

export const InputField = ({ label, type = "text", value, onChange, placeholder, icon: Icon }: any) => (
    <div className="space-y-1">
        <label className="text-sm font-medium text-gray-700">{label}</label>
        <div className="relative">
            {Icon && <div className="absolute inset-y-0 left-0 pl-3 flex items-center"><Icon size={16} className="text-gray-400" /></div>}
            <input
                type={type}
                value={value}
                onChange={onChange}
                className="pl-10 w-full px-4 py-2.5 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                placeholder={placeholder}
            />
        </div>
    </div>
);


export const TextAreaField = ({ label, value, onChange, placeholder }: any) => (
    <div className="md:col-span-2 space-y-1">
        <label className="text-sm font-medium text-gray-700">{label}</label>
        <textarea
            value={value}
            onChange={onChange}
            rows={4}
            className="w-full px-4 py-2.5 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
            placeholder={placeholder}
        />
    </div>
);


export const DateInputField = ({ label, value, onChange }: any) => (
    <div className="space-y-1">
        <label className="text-sm font-medium text-gray-700">{label}</label>
        <input
            type="date"
            value={value}
            onChange={onChange}
            className="w-full px-4 py-2.5 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
        />
    </div>
);


export const TimeInputField = ({ label, value, onChange }: any) => (
    <div className="space-y-1">
        <label className="text-sm font-medium text-gray-700">{label}</label>
        <div className="flex gap-4">
            <input
                type="time"
                value={value}
                onChange={onChange}
                className="w-full px-4 py-2.5 border border-gray-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
            />
        </div>
    </div>
);